import { Timestamp } from "../../domine/timestamp.types";
import { BrawlerStats } from "../domine/brawler-stats.types";
import { HttpFirestoreBrawlerStat } from "../firestore/firestore-battle-stats.types";
import { FirestoreFieldValue } from "../firestore/firestore.types";

export interface RankedStats {
  currentEvents: CurrentEvent[];
  event: Event;
}

export interface CurrentEvent {
  id: number;
  name: string;
  mode: string;
}

export interface Event {
  lastUpdate: Timestamp;
  id: number | null;
  name: string | null;
  mode: string | null;
  brawlersStats: BrawlerStats[];
}

export interface CurrentEvents {
  lastUpdate: Date;
  currentEvents: CurrentEvent[];
}

export const ALL_ID = "all";

export type RankedStatsId = typeof ALL_ID | `${number}`;

export interface HttpFirestoreCurrentEvent {
  lastUpdate: FirestoreFieldValue;
  currentEvents: {
    arrayValue: {
      values: {
        mapValue: {
          fields: {
            mode: FirestoreFieldValue;
            name: FirestoreFieldValue;
            id: FirestoreFieldValue;
          };
        };
      }[];
    };
  };
}

export interface HttpFirestoreEvent {
  id: FirestoreFieldValue;
  brawlersStats: {
    arrayValue: {
      values: HttpFirestoreBrawlerStat[];
    };
  };
  name: FirestoreFieldValue;
  mode: FirestoreFieldValue;
  lastUpdate: FirestoreFieldValue;
}
